module.exports = __webpack_public_path__ + "static/media/registration-icon.11656411.svg";